module.exports = __webpack_public_path__ + "img/homepage.d480e4ea.jpg";